import React from "react";

export default function Badge({ name = "badge" }) {
	return (
		<div className="text-blue-500 bg-blue-100 px-2 font-medium py-1 text-sm rounded-full">
			{name}
		</div>
	);
}
